// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3ZjAzTmGOfWTKP {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n._23pLlJ6d-QxzGf {\n  width: 14px;\n  height: 14px;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #FFFFFF;\n  border-radius: 3px;\n  padding: 1px;\n  background-color: #505F79;\n  padding-bottom: 2px;\n  margin-left: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "_3ZjAzTmGOfWTKP",
	"tooltipShortcut": "_23pLlJ6d-QxzGf"
};
export default ___CSS_LOADER_EXPORT___;
